import { z } from 'zod';
// NOTE: we used to model Json/ResourceKey as `z.lazy(() => z.union([...]))` for
// proper recursive validation. zod 4 + @asteasolutions/zod-to-openapi v8 blow
// the stack when walking such circular schemas during OpenAPI generation
// (isNullableSchema → safeParse(null) → ZodError → JSON.stringify on the
// lazy ref). Since runtime validation of arbitrary JSON is permissive anyway,
// model them as `z.any()` with a stable OpenAPI id and cast the public type.
export const jsonSchema = z
    .any()
    .openapi('JsonValue', { type: 'object' });
export const i18nResourceKeySchema = z
    .any()
    .openapi('I18nResourceKey', {
    type: 'object',
});
export const i18nResourceLanguageSchema = z.record(z.string(), i18nResourceKeySchema);
export const i18nResourceSchema = z.record(z.string(), i18nResourceLanguageSchema);
export const emailAttachmentSchema = z.object({
    filename: z.string(),
    /** Raw string content (e.g. an .ics body). Kept as a string so the options
     *  stay JSON-serializable across the email queue and HTTP render boundary. */
    content: z.string(),
    contentType: z.string().optional(),
    /** Set to base64 when `content` is a base64-encoded binary payload (e.g. PDF). */
    encoding: z.enum(['utf8', 'base64']).optional(),
});
export const emailOptionsSchema = z.object({
    to: z.string(),
    template: z.string(),
    locals: z.record(z.string(), jsonSchema).optional(),
    attachments: z.array(emailAttachmentSchema).optional(),
});
export const renderedEmailSchema = z.object({
    to: z.string(),
    template: z.string(),
    subject: z.string(),
    html: z.string(),
    text: z.string(),
});
